module.exports = __webpack_public_path__ + "static/media/icon_nav_project.ec6a3907.svg";